var map = {
	"./en-US": "bd30",
	"./en-US.ts": "bd30",
	"./fr-CA": "bf2a",
	"./fr-CA.ts": "bf2a",
	"./he-IL": "1dd0",
	"./he-IL.ts": "1dd0",
	"./template": "96ba",
	"./template.ts": "96ba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e6ea";